/* Bounded DOM enhancement; no catalog downloads, trackers, or persistent customer data. */
class SJStickyPurchase extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('.sj-sticky');
    this.trigger = this.querySelector('button');
    this.target = document.getElementById(this.dataset.target);
    if (!this.bar || !this.trigger || !this.target || !('IntersectionObserver' in window)) return;
    this.activate = () => {
      // Return to the current native product form so variant validation and app inputs stay authoritative.
      const form = document.getElementById(this.dataset.target);
      form?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      form?.querySelector('button[name="add"]')?.focus({ preventScroll: true });
    };
    this.trigger.addEventListener('click', this.activate);
    this.observer = new IntersectionObserver(([entry]) => {
      this.bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, { threshold: 0 });
    this.observer.observe(this.target);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.trigger?.removeEventListener('click', this.activate);
  }
}
if (!customElements.get('sj-sticky-purchase')) customElements.define('sj-sticky-purchase', SJStickyPurchase);
